import React, { FC, useEffect, useState } from "react";
import { ApplicationFeature, FormBaseType } from "@green0meter/api-client";
import { t } from "i18next";
import { isEmpty } from "lodash";

import Reports from "./Reports";

import { useGetReportsMetadata } from "@api";
import { CardTable, DownloadButton } from "@components/common";
import { useUserStore } from "@store/user";
import { formatDateUtc } from "@helpers";

interface ReportsContainerProps {
  formBaseType: FormBaseType;
  title: string;
  type: string;
  noReportsText: string;
  fillFormText: string;
}

const ReportsContainer: FC<ReportsContainerProps> = ({
  formBaseType,
  title,
  type,
  noReportsText,
  fillFormText,
}) => {
  const { user } = useUserStore();
  const { reportsMetadata, reportsMetadataEnabled, isSuccessReports } =
    useGetReportsMetadata(user, {
      formBaseType,
      relatedFeature: ApplicationFeature.VSME,
    });

  const [rows, setRows] = useState<CardTable["rows"]>([]);

  const columns: CardTable["columns"] = [
    {
      field: "name",
      title: t("common.fileName"),
      tableProps: {
        sx: {
          minWidth: 120,
        },
      },
    },
    {
      field: "createdAt",
      title: t("common.date"),
      tableProps: {
        width: 150,
      },
    },
    {
      field: "action",
      title: t("common.action"),
      tableProps: {
        sx: {
          width: 220,
        },
      },
    },
  ];

  useEffect(() => {
    if (reportsMetadata && !isEmpty(reportsMetadata)) {
      const _rows = reportsMetadata.map((report) => {
        return {
          name: report.name,
          createdAt: formatDateUtc(report.createdAt),
          action: <DownloadButton report={report} />,
        };
      });

      setRows(_rows);
    }
  }, [reportsMetadata]);

  return (
    reportsMetadataEnabled && (
      <Reports
        columns={columns}
        rows={rows}
        isLoaded={isSuccessReports}
        title={title}
        type={type}
        noReportsText={noReportsText}
        fillFormText={fillFormText}
      />
    )
  );
};

export default ReportsContainer;
